export default class {

    Id = null;
    
    Comment = null;
    
    Url = null;

    Category = null;

    IsReadOnlyCategory = false;

    mapFromDto(photoDto)
    {
        if(!Object.keys(photoDto).length)
            return this;

        this.Id = photoDto.Id;
        this.Comment = photoDto.Comment;
        this.Url = photoDto.Url;
        this.Category = photoDto.Category;
        this.IsReadOnlyCategory = photoDto.IsReadOnlyCategory;

        return this;
    }

    mapToDto(url) {
        
        let result = JSON.parse(JSON.stringify(this));

        result.Url = url; 

        return result;
    }

    isValid() {
        return Boolean(this.Category);
    }

}